import React from "react";
import "./NetBackground.css";

const NetBackground = () => (
  <div className="unique-net-bg" aria-hidden="true"></div>
);

export default NetBackground;